import React, { useEffect, useState } from "react";
import {
    collection,
    query,
    where,
    getDocs,
    getDoc,
    updateDoc,
    doc,
    serverTimestamp,
    writeBatch,
} from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";

const FriendRequests = () => {
    const { currentUser } = useAuth();
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchRequests = async () => {
        if (!currentUser) return;
        try {
            const q = query(
                collection(db, "friendRequests"),
                where("toUserId", "==", currentUser.uid),
                where("status", "==", "pending")
            );
            const snapshot = await getDocs(q);
            const reqs = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const data = docSnap.data();
                    const userRef = doc(db, "users", data.fromUserId);
                    const userSnap = await getDoc(userRef);
                    const fromUserData = userSnap.exists() ? userSnap.data() : {};
                    return {
                        id: docSnap.id,
                        ...data,
                        fromUserName: fromUserData.displayName || fromUserData.email || "Неизвестный пользователь"
                    };
                })
            );

            setRequests(reqs);
        } catch (error) {
            console.error("Ошибка при загрузке заявок:", error);
        }
    };

    useEffect(() => {
        fetchRequests();
    }, [currentUser]);

    const handleAccept = async (request) => {
        if (!currentUser) return;
        setLoading(true);

        try {
            const batch = writeBatch(db);

            // Обновить статус заявки
            const requestRef = doc(db, "friendRequests", request.id);
            batch.update(requestRef, {
                status: "accepted",
                respondedAt: serverTimestamp(),
            });

            if (!request.fromUserId || !currentUser.uid) {
                throw new Error("Отсутствуют необходимые идентификаторы пользователей");
            }

            const currentUserFriendRef = doc(
                db,
                "users",
                currentUser.uid,
                "friends",
                request.fromUserId
            );

            const otherUserFriendRef = doc(
                db,
                "users",
                request.fromUserId,
                "friends",
                currentUser.uid
            );

            // Добавляем в друзья обоих
            batch.set(
                currentUserFriendRef,
                { friendId: request.fromUserId, since: serverTimestamp() },
                { merge: true }
            );

            batch.set(
                otherUserFriendRef,
                { friendId: currentUser.uid, since: serverTimestamp() },
                { merge: true }
            );

            await batch.commit();

            // Убираем принятую заявку из локального стейта, чтобы UI обновился мгновенно
            setRequests(prev => prev.filter(r => r.id !== request.id));
        } catch (error) {
            alert("Ошибка при принятии заявки: " + error.message);
            console.error(error);
        }

        setLoading(false);
    };


    const handleReject = async (request) => {
        if (!currentUser) return;
        setLoading(true);
        try {
            const requestRef = doc(db, "friendRequests", request.id);
            await updateDoc(requestRef, { status: "rejected", respondedAt: serverTimestamp() });

            // Убираем отклонённую заявку из локального стейта
            setRequests(prev => prev.filter(r => r.id !== request.id));
        } catch (error) {
            alert("Ошибка при отклонении заявки: " + error.message);
            console.error(error);
        }
        setLoading(false);
    };

    if (!currentUser) return null;

    return (
        <div style={{ maxWidth: "100%", padding: "0 10px", margin: "20px auto", color: "white" }}>
            <h3 style={{ textAlign: "center", marginBottom: "15px" }}>Заявки в друзья</h3>
            {requests.length === 0 && <p style={{ textAlign: "center" }}>Нет новых заявок.</p>}
            {requests.map((req) => (
                <div
                    key={req.id}
                    style={{
                        background: "#222",
                        padding: "15px",
                        marginBottom: "15px",
                        borderRadius: "6px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <div style={{ wordBreak: "break-word" }}>
                        Пользователь <strong>{req.fromDisplayName || req.fromUserName}</strong> хочет добавить вас в друзья
                    </div>

                    <div style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "space-between"
                    }}>
                        <button
                            onClick={() => handleAccept(req)}
                            disabled={loading}
                            style={{
                                padding: "8px 12px",
                                background: "#4CAF50",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                flex: 1,
                                minWidth: 0,
                                whiteSpace: "nowrap"
                            }}
                        >
                            Принять
                        </button>
                        <button
                            onClick={() => handleReject(req)}
                            disabled={loading}
                            style={{
                                padding: "8px 12px",
                                background: "#f44336",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                flex: 1,
                                minWidth: 0,
                                whiteSpace: "nowrap"
                            }}
                        >
                            Отклонить
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FriendRequests;
